import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/common";
import { toast } from "sonner";
import { TicketDetail } from "./TicketDetail";

export default function TicketDetailPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const { can, user } = useAuth();
  const [detail, setDetail] = useState(null);
  const [agents, setAgents] = useState([]);
  const [canned, setCanned] = useState([]);
  const loadCanned = () => api.get("/canned-responses").then((r) => setCanned(r.data)).catch(() => {});
  const load = () => api.get("/tickets/" + id).then((r) => setDetail(r.data)).catch((e) => { toast.error(apiErr(e)); nav("/tickets"); });
  useEffect(() => {
    load();
    api.get("/ticket-agents").then((r) => setAgents(r.data)).catch(() => {});
    loadCanned();
    /* eslint-disable-next-line */
  }, [id]);

  if (!detail) return <div className="p-6"><Spinner /></div>;
  return <TicketDetail asPage detail={detail} setDetail={setDetail} agents={agents} canned={canned} can={can} reload={load} me={user} refreshCanned={loadCanned} />;
}
